import { Split, SplitItem, Stack, StackItem, TextContent, Text, Alert, DataListCell, DataListItem, DataListItemRow, DataListItemCells } from '@patternfly/react-core';
import React, { PropsWithChildren } from 'react';

import { BackendValidationErrorViewModel } from '../../store/global-types/store-errors';
import './section.css';
import { useTranslation } from 'react-i18next';
interface SectionProps {
    title?: string,
    isModified: boolean,
    hasValidationError: boolean,
    validationError: BackendValidationErrorViewModel | undefined,
}

const Section = (props: PropsWithChildren<SectionProps>) => {

    const { t } = useTranslation();

    const { title, isModified, hasValidationError, validationError, children } = props;

    const dataListCells = (
        <DataListCell key="modelRules" width={4}>
            <div className="section">
                <Stack>
                    <StackItem>
                        <Split>
                            {title && (
                                <SplitItem className="section-title">
                                    <TextContent>
                                        <Text><b>{title}{`${isModified ? '*' : ''}`}</b></Text>
                                    </TextContent>
                                </SplitItem>
                            )}
                            <SplitItem isFilled>
                                <Stack>
                                    {children}
                                </Stack>
                            </SplitItem>
                        </Split>
                    </StackItem>
                    {
                        hasValidationError && validationError && (
                            <StackItem className="output-section-error validation-error validation-error-box selectable">
                                <Alert variant="danger" isInline isPlain isExpandable title={t('common.validationError.message', { error: validationError.message })}>
                                    <div>Error type: {validationError.detail}</div>
                                    <div>Error ctx: {validationError.ctx}</div>
                                </Alert>
                            </StackItem>
                        )
                    }
                </Stack>
            </div>
        </DataListCell>
    );

    return (
        <DataListItem aria-labelledby={`Dose file customization for ${title}`} className='section-border-0'>
            <DataListItemRow className="model-selection-model-rules">
                <DataListItemCells dataListCells={dataListCells} />
            </DataListItemRow>
        </DataListItem>
    );
}

export default Section;
